import React, { useMemo } from 'react';

import { useJiraContext } from 'src/services/jira';

import { useSelectedProjects } from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/RuleFormContext';

import BaseAdditionalValueSelector from './BaseAdditionalValueSelector';
import { createAllowedValuesSource,
  createAutoCompleteUrlSource,
  createConstStringSource,
  createCustomerOrganizationsSource,
  createJiraGroupSource,
  createJiraUserSource,
  createPagerDutyNumberSource,
  createPagerDutyStringSource, createPagerDutyTimeFieldsSource,
  createPagerDutyUserFiledSource,
  createStaticTimeFieldsSource } from './sources';

const findOptionsSources = (field, projectKeys) => {
  const { schema: { type, items, system, custom }, autoCompleteUrl, allowedValues } = field || { schema: {} };
  const itemType = items || type;
  const sources = [];
  if (allowedValues) sources.push(createAllowedValuesSource(allowedValues));
  if (autoCompleteUrl
    && system !== 'labels' // has an xml suggestions, we don't handle that
    && itemType !== 'user' // we have separate suggestions for users
    && custom !== 'com.atlassian.jira.plugin.system.customfieldtypes:labels' // has an xml suggestions, we don't handle that
    && custom !== 'com.atlassian.servicedesk:sd-customer-organizations' // has invalid autoCompleteUrl, Atlassian provided another one - https://pagerduty.atlassian.net/browse/ITS-4805
  ) {
    sources.push(createAutoCompleteUrlSource(autoCompleteUrl, projectKeys));
  }

  if (itemType === 'user') {
    sources.push(createPagerDutyUserFiledSource());
    sources.push(createJiraUserSource());
  }

  if (itemType === 'datetime' || itemType === 'date') {
    sources.push(createStaticTimeFieldsSource());
    sources.push(createPagerDutyTimeFieldsSource());
  }

  if (itemType === 'string') {
    sources.push(createPagerDutyStringSource());
    sources.push(createConstStringSource());
  }

  if (itemType === 'number') {
    sources.push(createPagerDutyNumberSource());
    sources.push(createConstStringSource());
  }

  if (itemType === 'group') {
    sources.push(createJiraGroupSource());
  }

  if (custom === 'com.atlassian.servicedesk:sd-customer-organizations') {
    sources.push(createCustomerOrganizationsSource());
  }

  return sources;
};

const JiraFiledValueSelector = ({ name, value, field, onChange, onBlur, isMulti, isDisabled }) => {
  const projects = useSelectedProjects();
  const { context } = useJiraContext();
  const projectKeys = (projects || []).map(p => p.key).join(',');
  const optionSources = useMemo(() => findOptionsSources(field, projectKeys), [field, projectKeys]);

  return (
    <div>
      <BaseAdditionalValueSelector
        isDisabled={isDisabled}
        isClearable
        clearInputOnSelect
        placeholder={'set value(s)...'}
        optionSources={optionSources}
        isMulti={isMulti}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        hasIcons
        iconsBaseUrl={context?.browseBaseUrl}
      />
    </div>
  );
};

export const isFieldSupported = (filed) => {
  return findOptionsSources(filed).length > 0;
};

export default JiraFiledValueSelector;
